import { formatNumberForLocale } from "../../utils/locale";
import { Icons } from "../../utils/icons";

export const PastTransactions = ({ transactions, player }) => {
    return (
        <ul className="w-full pr-3 pl-3">
            {transactions.map((transaction, index) => (
                <li key={index}>
                    <div className="mt-5">
                        <div className="flex justify-between items-center">
                            <div className="flex items-center gap-3">
                                <Icons   avatar={transaction.avatar}   recipient={transaction.recipient}   sender={transaction.sender} /> 
                                <span className="text-xl">
                                    {transaction.sender === player
                                        ? transaction.recipient
                                        : transaction.sender}
                                </span>
                            </div>

                            <span
                                className={`text-xl text-right ${transaction.sender === player ? "" : "text-green-900"
                                    }`}
                            >
                                {transaction.sender === player
                                    ? `-${formatNumberForLocale(transaction.value)}€`
                                    : `+${formatNumberForLocale(transaction.value)} €`}
                            </span>
                        </div>
                    </div>
                </li>

            ))}
        </ul>
    );
};


